import React, { useEffect } from 'react';

const AboutSustanbilitysecondsection = () => {
    useEffect(() => {
        // Dynamically load the Vidyard embed script
        const embedScript = document.createElement('script');
        embedScript.type = 'text/javascript';
        embedScript.id = 'vidyard_embed_code_';
        embedScript.src = '//play.vidyard.com/.js?v=3.1.1&type=inline';
        setTimeout(() => {
            document.getElementById('vidyard_span_')?.appendChild(embedScript);
        }, 1000);
    }, []);

    return (
        <section id="section-3-box" >
            <style>
                {`
                    .lazy-background {
                        background-repeat: no-repeat;
                    }
                    .circle-bg-img {
                        background-image: url("");
                    }
                    .circle-bg-img.visible {
                        background-image: url(#);
                    }
                    .sustain-card {
                        background-color: #fff;
                        padding: 20px;
                        margin: 30px auto;
                        max-width: 900px;
                        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
                        text-align: center;
                        border-radius: 8px;
                    }
                    .sustain-img img {
                        max-width: 100%;
                        height: auto;
                        display: block;
                        margin: 0 auto;
                    }
                    @media (min-width: 300px) and (max-width: 767px) {
                        #vidyard_span_ {
                            width: 100% !important;
                            height: 220px !important;
                        }
                    }
                    @media (min-width: 768px) and (max-width: 1200px) {
                        #vidyard_span_ {
                            width: 100% !important;
                            height: 450px !important;
                        }
                    }
                `}
            </style>

            <div className="circle-bg lazy-background circle-bg-img visible">
                <div className="container">
                    <div className="section-3-circle">
                        <br></br>
                        <h2>
                            Creating equitable sustainable policies Envision has{' '}
                            <span style={{ color: 'rgb(4 133 155)' }}>
                                developed a sustainability policy as a guiding principle to ensure
                                consistency and accountability and integrate ESG{' '}
                            </span>
                            parameters across our business and value chain.
                        </h2>

                        <div className="sustain-card">
                            <div className="sustain-img">
                                <img
                                    src="#"
                                    alt="Ten Pillars of our Sustainability Policy"
                                    loading="lazy"
                                    height="498"
                                    width="842"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-center mt-4">
                                <a href="/path/to/sustainability-report.pdf" download>
                                    <button className="btn btn " style={{background:'#edcf39'}}>
                                        Read More
                                    </button>
                                </a>
                            </div>

                        <div className="section-3-circle-outer"></div>
                    </div>

                    <div id="vidyard_span_">&nbsp;</div>
                </div>
            </div>
        </section>
    );
};

export default AboutSustanbilitysecondsection;
